<template>
    <div>

        <live-header></live-header>

        <div class="main-content d-flex">
            <div class="filter" :class="{active: filterActive}">
                <form class="filter-form">
                    <div class="form-group" v-bind:class="{'disable': !user.id}">
                        <label>Filters</label>
                        <label class="radio-btn" v-b-tooltip.html="'You must log in </br> to use this function!'"
                               v-b-tooltip="{ trigger: 'hover', html: true, placement: 'bottom', customClass: 'disable-tooltip', disabled: user.id} ">Favorites
                            <input type="radio" name="filter" value='favourites' v-model='filter'
                                   @change="loadMore()" v-bind:disabled="!user.id">
                            <span class="checkmark"></span>
                        </label>
                        <label v-if="user" class="radio-btn"
                               v-b-tooltip.html="'You must log in </br> to use this function!'"
                               v-b-tooltip="{ trigger: 'hover', html: true, placement: 'bottom', customClass: 'disable-tooltip', disabled: user.id} ">Hyper
                            casual
                            <input type="radio" name="filter" value='hyper_casual' v-model='filter'
                                   @change="loadMore()" v-bind:disabled="!user.id">
                            <span class="checkmark"></span>
                        </label>
                    </div>

                    <div class="form-group">
                        <label>Store</label>
                        <label class="radio-btn">All
                            <input type="radio" name="store-type" value='all' v-model='filterStoreType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Google
                            <input type="radio" name="store-type" value='play_market' v-model='filterStoreType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Apple
                            <input type="radio" name="store-type" value='app_store' v-model='filterStoreType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Application type</label>
                        <label class="radio-btn">All
                            <input type="radio" value='all' v-model='filterAppType' name="app-type"
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Paid
                            <input type="radio" name="app-type" value='paid' v-model='filterAppType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Free
                            <input type="radio" name="app-type" value='free' v-model='filterAppType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Category</label>
                        <multiselect v-model="filterCategory" track-by="id" placeholder="Select one" label="name"
                                     :options="categoryList" :searchable="false" :allow-empty="false"
                                     :show-labels="false"
                                     @open="closeDateRage()" @input="loadMore()">
                            <template slot="singleLabel" slot-scope="{ option }" v-if="option.parentId">
                                <span>Games ({{ option.name }})</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <span :class="props.option.parentId ? 'sub-option' : ''">{{ props.option.name }}</span>
                            </template>
                        </multiselect>
                    </div>
                    <div class="form-group">
                        <label>Date range</label>
                        <date-picker v-model="filterDate" type="month" placeholder="All time"
                                     value-type="format" format="MM-YYYY" :append-to-body="false"
                                     @open="handleOpenDate" @close="handleCloseDate" ref="datePicker"
                                     @change="loadMore()">
                            <template v-slot:input="{ emit }">
                                <input placeholder="All time" name="date-range" type="text" autocomplete="off"
                                       class="mx-input"
                                       @click="handleDateRange()" v-model="filterDate" readonly>
                                <i class="mx-icon-arrow" @click="handleDateRange()"></i>
                            </template>
                            <template v-slot:header="{ emit }">
                                <!--                            <button class="mx-btn mx-btn-text custom-date-btn" @click="emit(new Date())">Today</button>-->
                                <button class="mx-btn mx-btn-text custom-date-btn"
                                        v-bind:class="filterDate ? '' : 'active'"
                                        @click="emit()">All Time
                                </button>
                            </template>
                        </date-picker>


                    </div>
                    <div class="form-group">
                        <label>Countries</label>
                        <multiselect v-model="filterCountry" track-by="id" label="label"
                                     placeholder="Selected countries"
                                     :options="countryList" :searchable="false" :show-labels="false"
                                     :allow-empty="false"
                                     @input="loadMore()">
                        </multiselect>
                    </div>
                    <div class="form-group">
                        <label>Countries limit</label>
                        <vue-slider
                            v-model="filterCountryLimit"
                            :adsorb="true"
                            :marks="countryCountList"
                            :included="true"
                            width="300px"
                            height="12px"
                            tooltip="none"
                            v-on:change="changeSliderStyles()"
                        ></vue-slider>
                    </div>
                    <div class="form-group mb-0">
                        <a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/storeglide">
                            <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee">
                            <span style="margin-left:5px;font-size:28px !important;">Buy me a coffee</span></a>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3">
                            <input type="checkbox" class="custom-control-input" id="remember" name="remember"
                                   v-model="filterRemember" @change="saveCookies()">
                            <label class="custom-control-label" for="remember">Remember my filter</label>
                        </div>
                    </div>
                    <div class="form-group d-lg-none d-block">
                        <div class="social">
                            <p class="social-description">Every day we publish video reviews on new hypercasual
                                games.</p>
                            <div class="icons">
                                <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                                    <img src="/img/instagram.svg" class="instagram"></a>
                                <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                                    <img src="/img/tik-tok.svg" class="tik-tok"></a>
                                <a href="https://t.me/storeglide" target="_blank">
                                    <img src="/img/telegram.svg" class="telegram"></a>
                            </div>
                        </div>
                    </div>
                </form>

                <instagram-widget v-if="!isMobile"></instagram-widget>
            </div>
            <div class="new-application-list">
                <form class="form-inline search-form" :class="{active: searchActive}">
                    <input class="form-control form-control-sm" type="text" placeholder="Search by app or publisher"
                           aria-label="Search" v-model="q" v-bind:class="{'search-fill': q !== ''}">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </form>

                <ul class="apps-list" v-if="results">
                    <template v-for="(result, idx) in results">
                        <li class="app" :id="'app-' + idx">
                            <div class="content">
                                <img src="/img/fire.svg" class="hot" v-if="user && isHot(result)">
                                <div class="logo" v-if="result.icon">
                                    <img v-lazy="result.icon" :alt="result.name"/>
                                </div>
                                <div class="description">
                                    <span class="name">{{ result.name }}</span>
                                    <a class="author" v-if="result.store_type == 'play_market'"
                                       :href="'https://play.google.com/store/apps/developer?id='+ result.publisher_name">{{
                                            result.publisher_name
                                        }}</a>
                                    <a v-if="result.store_type == 'app_store'" class="author"
                                       :href="result.publisher_id ? 'https://apps.apple.com/developer/id' + result.publisher_id : '#'">{{
                                            result.publisher_name
                                        }}</a>
                                    <span
                                        class="date">{{
                                            result.release_date | moment("add", "7 hours") | moment("from", "now")
                                        }}</span><span
                                    class="release-date">First release: {{
                                        result.release_date | moment("YYYY-MM-DD")
                                    }}</span>
                                    <span class="countries"
                                          v-if="result.locations !== null && JSON.parse(result.locations).length >= 5"
                                          v-b-tooltip.html="appCountries(result)"
                                          v-b-tooltip="{ trigger: 'hover', html: true, placement: 'bottom', customClass: 'v-country-tooltip'}">
                            {{ JSON.parse(result.locations).length }}  countries
                            </span>
                                    <span class="countries"
                                          v-if="result.locations !== null && JSON.parse(result.locations).length < 5">
                            <span v-for="(location, index) in JSON.parse(result.locations)">
                                {{ getLocationLabel(location) }}<span
                                v-if="index !== (JSON.parse(result.locations).length - 1)">, </span>
                            </span>
                            </span>
                                </div>
                                <div class="additional">

                                    <a :href="result.url" class="download"
                                       v-bind:class="result.store_type == 'app_store' ? 'app-store' : 'play-market'"
                                       target="_blank"
                                       @click="sendAppEvent(result.id)"
                                       title="Go to App Store">Download</a>
                                    <div class="options">
                                        <social-share :id="idx" :url="shareUrl + '&app_id=' + idx"
                                                      title="'Storeglide'"></social-share>
                                        <img
                                            :src="user.id ? result.is_favourite ? '/img/fill_star.svg':'/img/stroke_star.svg' : '/img/disable_stroke_star.svg'"
                                            v-bind:class="{'disable': !user.id}"
                                            class="favourite-icon" @click="markFavourite(idx)"
                                            :id="'tooltip-' + result.id">

                                        <b-tooltip ref="tooltip" :target="'tooltip-' + result.id" placement="bottom"
                                                   custom-class="disable-tooltip" :disabled="user.id != null">
                                            You must log in </br> to use this function!
                                        </b-tooltip>
                                    </div>

                                </div>

                            </div>

                            <div class="gallery-container" v-if="result.gallery">
                                <ul class="gallery">

                                    <li class="item" v-for="gallery in JSON.parse(result.gallery)">
                                        <img v-if="result.store_type == 'app_store'" :src="imageFormatting(gallery)"
                                             alt="#"/>
                                        <img v-if="result.store_type != 'app_store'" :src="gallery" alt="#"/>
                                    </li>
                                </ul>
                            </div>
                        </li>

<!--                        <li v-if="idx == 6" class="commercial">-->
<!--                            <a href="https://hgconf.com/" target="_blank" @click="sendAdEvent()">-->
<!--                                <img src="/img/HGC_14-15_11_2022.png" class="img-fluid">-->
<!--                            </a>-->
<!--                        </li>-->

                                                <li v-if="idx == 6" class="commercial">
                                                    <a href="https://hgconf.com/" target="_blank" @click="sendAdEvent()">
                                                        <video width="100%" autoplay loop muted playsinline>
                                                            <source src="/video/HGC_ads_02-03_02_2023.mp4"
                                                                    type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
                                                        </video>
                                                    </a>
                                                </li>
                        <li class="mobile-instagram-widget" v-if="idx == 1">
                            <instagram-widget></instagram-widget>
                        </li>

                    </template>
                </ul>


                <div class="not-found" v-if="!inProgress && results.length == 0">
                    <img src="/img/not_found.svg" class="emoji">
                    <p>No added applications.</p>
                    <p>Click<img src="/img/stroke_star.svg" class="star">to track favourite apps. </p>
                </div>

                <b-pagination-nav v-if="countPage > 1"
                                  v-model="currentPage"
                                  :link-gen="linkGen"
                                  :number-of-pages="countPage"
                                  first-number
                                  last-number
                                  prev-class="nav-prev"
                                  next-class="nav-next"
                                  use-router>

                    <template #next-text><p @click="loadMore(countPage - currentPage)">Next page</p></template>
                    <template #page="{ page, active }">
                        <a @click="loadMore(countPage - (page - 1));">{{ countPage - (page - 1) }}</a>
                    </template>

                </b-pagination-nav>
            </div>
            <button class="top-btn" @click="scrollToTop()" v-if="results"><img src="/img/top_btn_arrow.svg"></button>
        </div>
    </div>


</template>

<script>
import moment from "moment";
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import {VBTooltipPlugin} from 'bootstrap-vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import LiveHeader from './custom/LiveHeaderComponent';
import {mapGetters} from "vuex";

export default {
    name: 'App',
    components: {
        LiveHeader,
        VueSlider,
        VBTooltipPlugin,
        DatePicker
    },
    computed: mapGetters(['searchActive', 'filterActive']),
    data() {
        return {
            q: this.getFilterData("q") ? this.getFilterData("q") : '',
            results: [],
            currentPage: this.getFilterData("page") ? this.getFilterData("page") : 0,
            countPage: 0,
            bottom: false,
            datePickerClickCount: 0,
            inProgress: true,
            filterDate: this.getFilterData("date-range") && this.getFilterData("date-range") !== 'null' ? this.getFilterData("date-range") : null,
            filterRemember: this.getFilterData("remember") ? this.getFilterData("remember") : false,
            filterStoreType: this.getFilterData("store-type") ? this.getFilterData("store-type") : 'all',
            filterAppType: this.getFilterData("app-type") ? this.getFilterData("app-type") : 'all',
            filterCategory: this.getFilterData("category-id") ? this.getFilterData("category-id") : {
                id: 6014,
                name: 'Games'
            },
            filter: this.getFilterData("type") ? this.getFilterData("type") : '',
            categoryList: [],
            filterCountry: this.getFilterData("location-id") && this.getFilterData("location-id") != 0 ? this.getFilterData("location-id") : {
                id: 0,
                label: 'All Countries'
            },
            countryList: [],
            filterCountryLimit: this.getFilterData("country-limit") ? this.getFilterData("country-limit") : 100,
            countryCountList: {
                '0': '1',
                '20': '5',
                '40': '10',
                '100': 'All',
            },
            commercialImages: [
                'my_games_1.png',
                'my_games_2.png',
                'my_games_3.png',
                'my_games_4.png',
                'my_games_5.png',
            ],
            user: {},
            isMobile: window.innerWidth > 991 ? false : true,
            shareUrl: window.location.href,
            scrollAppId: this.$route.query['app_id'] ? this.$route.query['app_id'] : null,
            loader: this.$loading.show({loader: 'dots', backgroundColor: '#ffffff', opacity: 0}),
        };

    },

    watch: {
        q(after, before) {
            this.loadMore();
        },

        inProgress() {
            if (this.inProgress) {
                this.loader = this.$loading.show({loader: 'dots', backgroundColor: '#ffffff', opacity: 0});
            } else {
                this.loader.hide();
            }
        },
    },

    mounted() {
        this.loadMore(this.currentPage);
        this.loadCountries();
        this.loadCategories();
        this.loadUser();

        $('.favourite-btn:not(.disabled)').on('click', () => {

            if ($('.favourite-btn').hasClass('is-active')) {
                this.filter = 'favourites';
            } else {
                this.filter = '';
            }
            this.loadMore(0);
        });


    },
    updated() {

        if (this.scrollAppId) {
            var element = $("#app-" + this.scrollAppId);

            if (element.length) {
                var top = element.last().offset().top;
                var width = $(window).width();
                if (width <= 991) {
                    top = top - 60;
                }

                window.scrollTo(0, top);
                this.scrollAppId = null;
            }

        }

    },
    methods: {
        getFilterData($queryKey) {
            if (this.$route.query[$queryKey]) {
                return this.$route.query[$queryKey];
            }

            if (this.$cookies.isKey('new-filter-' + $queryKey)) {

                return this.$cookies.get('new-filter-' + $queryKey);
            }

            return null;
        },
        linkGen(pageNum) {

            const regex = /page=\d+/;
            return this.$router.currentRoute.fullPath.replace(regex, 'page=' + (this.countPage - pageNum + 1));
        },
        bottomVisible() {
            return $(window).scrollTop() + $(window).height() > $(document).height() - 300;
        },
        scrollToTop() {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        loadMore: _.debounce(async function (page = 0) {

            await this.$recaptchaLoaded()
            var token = await this.$recaptcha('homepage');

            this.saveCookies();
            this.inProgress = true;
            var params = {q: this.q, page: page};
            params['store-type'] = this.filterStoreType;
            params['app-type'] = this.filterAppType;
            params['category-id'] = this.filterCategory.id;
            params['location-id'] = this.filterCountry.id;
            params['date-range'] = this.filterDate;
            params['country-limit'] = this.filterCountryLimit;

            if (this.filter) {
                params['filter'] = this.filter;
            }

            this.$router.push({path: 'live', query: params}).catch(err => {
            })

            this.shareUrl = window.location.href;

            if (this.user) {
                params['user-id'] = this.user.id
            }
            this.scrollToTop();

            axios.get("/api/new-application", {
                params: params, headers: {'Api-token': token}
            }).then(response => {

                this.results = response.data.data;
                this.countPage = response.data.last_page;
                this.currentPage = this.countPage - (response.data.current_page - 1);
                this.inProgress = false;

            });

        }, 500),
        loadCountries: function (page = 1) {
            axios.get("/api/countries").then(response => {
                this.countryList = [{
                    id: 0,
                    label: 'All Countries'
                }];
                this.countryList = this.countryList.concat(response.data)
                var locationId = this.getFilterData("location-id");

                if (locationId && locationId != 0) {
                    this.filterCountry = this.countryList.find(location => location.id === parseInt(locationId));
                }
            });
        },
        loadCategories: function (page = 1) {
            axios.get("/api/categories").then(response => {
                this.categoryList = response.data;
                var categoryId = this.getFilterData("category-id");
                if (categoryId) {
                    this.filterCategory = this.categoryList.find(category => category.id === parseInt(categoryId));
                }

            });
        },
        loadUser: function () {
            axios.get("/auth/get-user").then(response => {
                this.user = response.data;
            });
        },

        highlight(text) {
            return text.replace(new RegExp(this.q, 'gi'), '<span style="color:red">$&</span>');
        },
        imageFormatting(text) {
            return String(text).slice(0, -13) + '318x318bb.jpg';
        },
        sendAppEvent(id) {
            ga('send', 'event', {
                'eventAction': 'game_pressed',
                'eventValue': id
            });
        },
        sendAdEvent() {
            ga('send', 'event', {
                'eventAction': 'ad_clicked',
                'eventValue': 'https://hgconf.com/'
            });
        },
        markFavourite(id) {

            if (!this.user.id) {
                var root = this;
                root.$refs.tooltip[id].$emit('open');
                setTimeout(function () {
                    root.$refs.tooltip[id].$emit('close');
                }, 2000);
                return;
            }

            if (!this.results[id].is_favourite) {
                axios.post("/api/favourite/create", {
                    user_id: this.user.id,
                    app_id: this.results[id].id,
                    type: 'live'

                }).then(response => {
                    if (response.data.status) {
                        this.results[id].is_favourite = true;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                });

            } else {

                axios.post("/api/favourite/delete", {
                    user_id: this.user.id,
                    app_id: this.results[id].id,
                    type: 'live'
                }).then(response => {

                    if (response.data.status) {
                        this.results[id].is_favourite = false;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                    if (this.filter == 'favourites') {
                        this.results.splice(id, 1);
                    }

                });

            }

        },
        changeSliderStyles() {
            var elements = $(".vue-slider-mark .vue-slider-mark-label");
            elements.css({"color": "#C3C3CA", "font-size": "14px"});

            if (this.countrySlider === '100') {
                elements.eq(3).css({"color": "#202124", "font-size": "20px"});
            }
            if (this.countrySlider === '40') {
                elements.eq(2).css({"color": "#202124", "font-size": "20px"});
            }
            if (this.countrySlider === '20') {
                elements.eq(1).css({"color": "#202124", "font-size": "20px"});
            }
            if (this.countrySlider === '0') {
                elements.eq(0).css({"color": "#202124", "font-size": "20px"});
            }
            this.loadMore();
        },
        appCountries(result) {
            var countries = JSON.parse(JSON.stringify(this.countryList));
            var locations = JSON.parse(result.locations);
            var count = locations.length;

            $.each(countries, function (i, item) {
                var valObj = locations.filter(function (elem) {
                    if (elem == item.code) return elem;
                });
                if (valObj.length > 0) {
                    item.active = 1;
                }
            });


            var htmlTemplate = '<p>Released in ' + count + ' countries:</p>';
            htmlTemplate += '<ul>';

            $.each(countries, function (i, item) {
                if (item.active) {
                    htmlTemplate += '<li class="active">' + item.label + '</li>';
                } else {
                    htmlTemplate += '<li>' + item.label + '</li>';
                }
            });

            htmlTemplate += '</ul>';


            return htmlTemplate;
        },
        handleDateRange() {
            this.datePickerClickCount++;
            if (this.datePickerClickCount === 2) {
                this.$refs.datePicker.closePopup();
                this.datePickerClickCount = 0;
            }
        },
        handleOpenDate() {
            $('.mx-input').css({"border-bottom-right-radius": "0", "border-bottom-left-radius": "0"});
            $('.mx-input-wrapper').addClass('mx-input-wrapper--active');
        },
        handleCloseDate() {
            $('.mx-input').css({"border-radius": "20px"});
            $('.mx-input-wrapper').removeClass('mx-input-wrapper--active');
        },
        closeDateRage() {
            if (this.$refs.datePicker.popupVisible) {
                this.$refs.datePicker.closePopup()
            }
        },
        getLocationLabel(code) {

            var location = this.countryList.filter(function (elem) {
                if (elem.code == code) return elem;
            });

            return location[0].label;
        },
        saveCookies() {
            if (this.filterRemember) {
                this.$cookies.set('new-filter-store-type', this.filterStoreType);
                this.$cookies.set('new-filter-app-type', this.filterAppType);
                this.$cookies.set('new-filter-category-id', this.filterCategory.id);
                this.$cookies.set('new-filter-location-id', this.filterCountry.id);
                this.$cookies.set('new-filter-date-range', this.filterDate);
                this.$cookies.set('new-filter-country-limit', this.filterCountryLimit);
                this.$cookies.set('new-filter-remember', this.filterRemember);
                this.$cookies.set('new-filter-type', this.filter);
            } else {
                this.$cookies.remove("new-filter-store-type");
                this.$cookies.remove("new-filter-app-type");
                this.$cookies.remove("new-filter-category-id");
                this.$cookies.remove("new-filter-location-id");
                this.$cookies.remove("new-filter-date-range");
                this.$cookies.remove("new-filter-country-limit");
                this.$cookies.remove("new-filter-remember");
                this.$cookies.remove("new-filter-type");
            }
        },
        isHot(item) {
            var releaseDate = moment(item.release_date);
            var findDate = moment(item.created_at);
            var diff = moment.duration(findDate.diff(releaseDate)).asDays();
            var now = moment();
            var diff_now = moment.duration(moment().diff(findDate)).asDays();
            if (diff <= 7 && diff_now <= 7) {
                return true
            }
            return false;
        },

    },
}

</script>
